import Icon from './icon';
export default {
  Icon,
  title: 'Polygon',
  hotkey: 'p'
};